<template>
  <v-autocomplete
    v-model="model"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    :item-value="itemValue"
    :item-text="itemText"
    :label="label"
    cache-items
    :rules="isRequired ? [() => $v.value.required || 'Campo obrigatório'] : []"
    outlined
    :return-object="returnObject"
    :placeholder="placeholder"
    append-icon="mdi-chevron-down-circle"
    :hide-no-data="!search || loading || search.length < 3"
    :no-data-text="noDataText"
    class="custom-autocomplete"
    @change="$emit('on-change', $event)"
    :disabled="disabled"
    :chips="chips"
    :multiple="multiple"
    deletable-chips
    ref="customAutoComplete"
  >
    <template slot="prepend" v-if="$slots.prepend">
      <slot name="prepend"></slot>
    </template>
  </v-autocomplete>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  validations: {
    value: {
      required
    }
  },
  props: {
    loading: {
      default: false
    },
    value: [String, Object, Array],
    items: Array,
    label: String,
    itemValue: {
      default: null
    },
    itemText: {
      default: null
    },
    returnObject: {
      default: false
    },
    noDataText: {
      default: 'Ops, não encontramos nenhum dado'
    },
    placeholder: {
      default: 'Faça uma busca'
    },
    disabled: {
      default: false
    },
    chips: {
      default: false
    },
    multiple: {
      default: false
    },
    isRequired: {
      default: true
    }
  },
  data: () => ({
    search: '',
    timerId: null
  }),
  computed: {
    validateSearch() {
      return !(!this.search || this.search.length < 3)
    },
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    search(val) {
      if (!this.validateSearch) return
      this.$emit('loading', true)
      clearTimeout(this.timerId)
      this.timerId = setTimeout(() => {
        this.$emit('on-search', val)
      }, 500)
    }
  }
}
</script>

<style scoped>
.custom-autocomplete >>> .v-input__append-inner {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
</style>
